<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'centraisCrud'"
          crudName="Centrais"
          newText="Nova"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "centraisTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "central_id",
        "nome",
        "estado_id",
        "municipio_id",
        "telefone",
        "actions",
      ],
      tableData: [
        "central_id",
        "nome",
        "estado_id",
        "municipio_id",
        "telefone",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["central_id", "nome", "estado_id", "municipio_id"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          central_id: "ID",
          nome: "Nome",
          estado_id: "Estado",
          municipio_id: "Município",
          telefone: "Telefone",
          actions: "Ações",
        },
        sortable: ["central_id", "nome", "estado_id", "municipio_id"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {
          estado_id: function (h, row, index) {
            return row.estado ? row.estado.uf_nome : "Indisponível";
          },
          municipio_id: function (h, row, index) {
            return row.municipio
              ? row.municipio.municipio_nome
              : "Indisponível";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["municipio", "estado"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "centrais",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        central_id: "central_id",
        nome: "nome",
        municipio_id: "municipio[municipio_nome]",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>